import {
  NBS_API_GET_MY_MATCHES_REQUEST,
  NBS_API_GET_MY_MATCHES_SUCCESS,
  NBS_API_GET_MY_MATCHES_FAILURE,
  RESET_GET_MY_MATCHES
} from '../../constants/actions';

const initialState = {
  isFetching: null,
  error: null,
  timestamp: null,
  response: {},
  status: null
};

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_MY_MATCHES_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: false,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'request'
      };
    case NBS_API_GET_MY_MATCHES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        response: action.response,
        timestamp: new Date().toUTCString(),
        status: 'success'
      };
    case NBS_API_GET_MY_MATCHES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
        response: {},
        timestamp: new Date().toUTCString(),
        status: 'fail'
      };
    case RESET_GET_MY_MATCHES:
      return initialState;
    default:
      return state;
  }
}
